import { api, applyQueryString } from 'services';
import {
  ScheduledReportType,
  ScheduledReportStatus,
  ScheduledReport,
} from 'contracts/scheduledRepports';

type ListReportsInput = {
  type: ScheduledReportType;
  statuses?: ScheduledReportStatus[];
};

export function useListScheduledReports<T extends ScheduledReport>() {
  const listReports = async (payload: ListReportsInput): Promise<T[]> => {
    const url = applyQueryString('/scheduled-reports', payload);
    const { data } = await api.get<T[]>(url);

    return data;
  };

  return {
    listReports,
  };
}
